// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__Btn from "../../../html/Btn.js";
import * as Buhta_cabinet__Checkbox from "../../../html/Checkbox.js";
import * as Buhta_cabinet__Dropdown from "../../../html/Dropdown.js";
import * as Buhta_cabinet__Field from "../../../html/Field.js";
import * as Buhta_cabinet__Kassa from "../../../../grpc/Kassa.js";
import * as Buhta_cabinet__Kkm from "../../../../models/Kkm.js";
import * as Buhta_cabinet__RadioButton from "../../../html/RadioButton.js";
import * as Buhta_cabinet__ToastSender from "../../../../util/ToastSender.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../../../packages/core/lib/Toast.js";
import * as Curry from "melange.js/curry.js";
import * as $$Promise from "../../../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function KkmSettingsGeneral$DomainSelect(Props) {
  let default_domain = Props.default_domain;
  let onDomainTypeSelect = Props.onDomainTypeSelect;
  const match = React.useState(function () {
    return false;
  });
  const setIsDropdownShown = match[1];
  const activator = function (param) {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
          children: Buhta_cabinet__Kkm.DomainType.toString(default_domain)
        }),
        JsxRuntime.jsx("img", {
          className: "w-6 h-6",
          src: StaticAsset.src("/static/icons/select-arrows.svg")
        }),
        JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
          className: "absolute -top-2.5 left-2 bg-white px-2 text-gray-medium",
          children: "Отрасль по умолчанию"
        })
      ],
      className: "rounded-sm border border-gray-main px-4 py-[9px] mt-6 flex justify-between relative items-center"
    });
  };
  return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
    align: "BottomCenter",
    activator: activator,
    background: "bg-white",
    isDropdownShown: match[0],
    setIsDropdownShown: setIsDropdownShown,
    children: JsxRuntime.jsx("div", {
      children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex({
        hd: /* DOMAIN_TYPE_TRADING */ 1,
        tl: {
          hd: /* DOMAIN_TYPE_SERVICES */ 2,
          tl: {
            hd: /* DOMAIN_TYPE_GASOIL */ 3,
            tl: {
              hd: /* DOMAIN_TYPE_HOTELS */ 4,
              tl: {
                hd: /* DOMAIN_TYPE_TAXI */ 5,
                tl: {
                  hd: /* DOMAIN_TYPE_PARKING */ 6,
                  tl: /* [] */ 0
                }
              }
            }
          }
        }
      }, (function (index, dt) {
        const Key = "dt-" + String(index);
        return JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Buhta_components__Text.P.make, {
            children: Buhta_cabinet__Kkm.DomainType.toString(dt)
          }),
          className: "flex items-center space-x-2 px-4 py-1.5 hover:bg-gray-light cursor-pointer",
          onClick: (function (param) {
            Curry._1(onDomainTypeSelect, dt);
            Curry._1(setIsDropdownShown, (function (param) {
              return false;
            }));
          })
        }, Key);
      }))),
      className: "py-2 flex flex-col"
    })
  });
}

const DomainSelect = {
  make: KkmSettingsGeneral$DomainSelect
};

function KkmSettingsGeneral(Props) {
  let kkm = Props.kkm;
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
  const dispatchToasts = match$1[1];
  const match$2 = React.useState(function () {
    return kkm.name;
  });
  const setName = match$2[1];
  const name = match$2[0];
  const p = kkm.preferences;
  const preferences = p !== undefined ? p : ({
      allow_autoclose_shift: false,
      allow_autoclose_withdraw: false,
      allow_autotax: false,
      allow_ui_sales: false,
      allow_ui_purchases: false,
      allow_ui_storno: false,
      allow_ui_markup_discount: false,
      default_domain: /* DOMAIN_TYPE_UNSPECIFIED */ 0,
      receipt_lang: ""
    });
  const match$3 = React.useState(function () {
    return preferences.allow_autoclose_shift;
  });
  const set_allow_autoclose_shift = match$3[1];
  const allow_autoclose_shift = match$3[0];
  const match$4 = React.useState(function () {
    return preferences.allow_autoclose_withdraw;
  });
  const set_allow_autoclose_withdraw = match$4[1];
  const allow_autoclose_withdraw = match$4[0];
  const match$5 = React.useState(function () {
    return preferences.allow_autotax;
  });
  const set_allow_autotax = match$5[1];
  const allow_autotax = match$5[0];
  const match$6 = React.useState(function () {
    return preferences.allow_ui_sales;
  });
  const allow_ui_sales = match$6[0];
  const match$7 = React.useState(function () {
    return preferences.allow_ui_markup_discount;
  });
  const set_allow_ui_markup_discount = match$7[1];
  const allow_ui_markup_discount = match$7[0];
  const match$8 = React.useState(function () {
    return preferences.default_domain;
  });
  const set_default_domain = match$8[1];
  const default_domain = match$8[0];
  const match$9 = React.useState(function () {
    return preferences.receipt_lang;
  });
  const set_receipt_lang = match$9[1];
  const receipt_lang = match$9[0];
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_cabinet__Field.make, {
            label: "Название",
            type_: "text",
            name: "name",
            size: "m",
            required: true,
            onChange: (function (value) {
              Curry._1(setName, (function (param) {
                return value;
              }));
            }),
            value: name
          }),
          JsxRuntime.jsx(KkmSettingsGeneral$DomainSelect, {
            default_domain: default_domain,
            onDomainTypeSelect: (function (dt) {
              Curry._1(set_default_domain, (function (param) {
                return dt;
              }));
            })
          })
        ],
        className: "bg-white lg:w-140.5 p-6 lg:p-10 rounded-sm shadow-card"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_components__Text.Label.make, {
            className: "text-default-gray",
            children: "Настройки смены"
          }),
          JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
            isChecked: allow_autoclose_shift,
            onChange: (function (param) {
              Curry._1(set_allow_autoclose_shift, (function (param) {
                return !allow_autoclose_shift;
              }));
            }),
            text: "Закрывать смену автоматически",
            subText: "Раз в 24 часа или после 1000 чеков",
            className: "mt-6"
          }),
          JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
            isChecked: allow_autoclose_withdraw,
            onChange: (function (param) {
              Curry._1(set_allow_autoclose_withdraw, (function (param) {
                return !allow_autoclose_withdraw;
              }));
            }),
            text: "Изымать наличость при закрытии смены",
            className: "mt-4"
          })
        ],
        className: "bg-white lg:w-140.5 p-6 lg:p-10 mt-6 lg:mt-2 rounded-sm shadow-card"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_components__Text.Label.make, {
            className: "text-default-gray",
            children: "Настройки режима"
          }),
          JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
            isChecked: allow_autotax,
            onChange: (function (param) {
              Curry._1(set_allow_autotax, (function (param) {
                return !allow_autotax;
              }));
            }),
            text: "Режим НДС",
            subText: "Добавление налога в стоимость",
            className: "mt-6"
          }),
          JsxRuntime.jsx(Buhta_cabinet__Checkbox.make, {
            isChecked: allow_ui_markup_discount,
            onChange: (function (param) {
              Curry._1(set_allow_ui_markup_discount, (function (param) {
                return !allow_ui_markup_discount;
              }));
            }),
            text: "Режим наценок и скидок",
            subText: "Возможность добавлять наценки и скидки",
            className: "mt-6"
          })
        ],
        className: "bg-white lg:w-140.5 p-6 lg:p-10 mt-6 lg:mt-2 rounded-sm shadow-card"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Buhta_components__Text.Label.make, {
            className: "text-default-gray",
            children: "Язык чека"
          }),
          JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
            className: "mt-6",
            checked: receipt_lang === "",
            onChange: (function (param) {
              Curry._1(set_receipt_lang, (function (param) {
                return "";
              }));
            }),
            children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: "ml-1",
              children: "По умолчанию"
            })
          }),
          JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
            className: "mt-4",
            checked: receipt_lang === "kk",
            onChange: (function (param) {
              Curry._1(set_receipt_lang, (function (param) {
                return "kk";
              }));
            }),
            children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: "ml-1",
              children: "Казахский"
            })
          }),
          JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
            className: "mt-4",
            checked: receipt_lang === "ru",
            onChange: (function (param) {
              Curry._1(set_receipt_lang, (function (param) {
                return "ru";
              }));
            }),
            children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: "ml-1",
              children: "Русский"
            })
          }),
          JsxRuntime.jsx(Buhta_cabinet__RadioButton.make, {
            className: "mt-4",
            checked: receipt_lang === "en",
            onChange: (function (param) {
              Curry._1(set_receipt_lang, (function (param) {
                return "en";
              }));
            }),
            children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
              className: "ml-1",
              children: "Английский"
            })
          })
        ],
        className: "bg-white w-full lg:w-140.5 p-6 lg:p-10 mt-6 lg:mt-2 rounded-sm shadow-card"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
          title: "Сохранить",
          onClick: (function (param) {
            const updateData_preferences = {
              allow_autoclose_shift: allow_autoclose_shift,
              allow_autoclose_withdraw: allow_autoclose_withdraw,
              allow_autotax: allow_autotax,
              allow_ui_sales: allow_ui_sales,
              allow_ui_markup_discount: allow_ui_markup_discount,
              default_domain: default_domain,
              receipt_lang: receipt_lang
            };
            const updateData = {
              name: name,
              preferences: updateData_preferences
            };
            const __x = Buhta_cabinet__Kassa.KkmManagerService.update(tenant, kkm.id, updateData);
            $$Promise.get(__x, (function (result) {
              if (result.TAG === /* Ok */ 0) {
                return Curry._1(dispatchToasts, {
                  TAG: /* Add */ 0,
                  _0: {
                    id: Buhta_core__Toast.generateId(undefined),
                    text: "Настройки сохранены",
                    kind: "success",
                    onClick: (function (param) {
                      
                    })
                  }
                });
              } else {
                return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при сохранении.");
              }
            }));
          }),
          className: "w-full lg:w-auto px-6 py-3",
          text: deviceType === "mobile" ? /* He5 */ 1 : /* He4 */ 0
        }),
        className: "w-full lg:w-140.5 mt-6 flex lg:justify-end"
      })
    ],
    className: "px-4 pt-6 pb-10 lg:px-0"
  });
}

const make = KkmSettingsGeneral;

export {
  DomainSelect,
  make,
}
/* Buhta_cabinet__Btn Not a pure module */
